import {
  renderTime,
} from '../../userUtils';
import { publicWarningEventStartTime } from '../../publicWarningTime';

const getCommon = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    id: productEventId,
    content,
  } = event;

  const {
    ackRequired,
    productId,
  } = content;
  const {
    criteria,
    warnings,
    warningNumber,
  } = details;
  const {
    severity: severityName,
    severityId,
  } = criteria;

  const lastWarning = warnings[warnings.length - 1];
  const {
    warningVersion: version,
    issueTime: originalIssueTime,
  } = lastWarning;
  const issueTime = renderTime(originalIssueTime, userPreferences);

  const status = '';

  return {
    productEventId,
    productId,
    status,
    version,
    ackRequired,
    severityName,
    severityId,
    warningNumber,
    issueTime,
  };
};

const getListFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;

  const {
    expireTime,
    criteria,
    warningNumber,
  } = details;


  const {
    eventType: criteriaName,
  } = criteria;

  const heading = {
    key: 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.PUBLIC_WARNING_NOTIFICATIONS',
    params: {
      productName,
      warningNumber,
      criteriaName,
    },
  };

  const validTime = publicWarningEventStartTime(details);
  const startTime = validTime ? renderTime(validTime, userPreferences, true) : '';
  const endTime = renderTime(expireTime, userPreferences);

  const subtitle = startTime ? `${startTime} to ${endTime}` : '';
  return {
    heading,
    subtitle,
  };
};

const getMapFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;
  const {
    expireTime,
    warningNumber,
    warnings,
    criteria,
  } = details;

  const lastWarning = warnings[warnings.length - 1];
  const {
    bbox,
  } = lastWarning;
  const {
    eventType: criteriaName,
  } = criteria;

  const heading = {
    key: 'PRODUCT_DETAILS.MAP.HEADERS.PUBLIC_WARNING_NOTIFICATIONS',
    params: {
      warningNumber,
    },
  };

  const subtitle = criteriaName;
  const endTime = renderTime(expireTime, userPreferences);
  const validTime = publicWarningEventStartTime(details);
  const startTime = validTime ? renderTime(validTime, userPreferences) : '';
  const isPointInTime = false;

  return {
    heading,
    subtitle,
    endTime,
    startTime,
    bbox,
    isPointInTime,
  };
};

const getState = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    state,
  } = event;

  const {
    read,
    acked,
  } = state;

  return {
    read,
    acked,
    playingSound,
  };
};

const getFeatures = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  map: getMapFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  list: getListFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});


export default (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  common: getCommon(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  state: getState(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  features: getFeatures(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});
